import { NgModule } from '@angular/core';
import { SeparateCamelCasePipe } from './separate-camel-case.pipe';
import {LengthConverterPipe} from './length-converter.pipe';
import {ColorPipe} from './color.pipe';

@NgModule({
  imports: [],
  declarations: [
    SeparateCamelCasePipe,
    LengthConverterPipe,
    ColorPipe,
  ],
  exports: [
    SeparateCamelCasePipe,
    LengthConverterPipe,
    ColorPipe,
  ],
  providers: [LengthConverterPipe],
})
export class ApplicationPipesModule {
}
